import { Alert } from "react-bootstrap";

interface LoadingMessageProps {
  message:string;
  style?: {[key:string]:string};
}

function LoadingMessage(props:LoadingMessageProps) {
  const alertStyle = { marginBottom: '1px', height: '30px', lineHeight:'30px', padding: '0px 15px', ...props.style };
  const fontStyle = { fontSize: '90%', color : 'grey'};
  return <Alert variant="dark" style={alertStyle} className="border border-dark">
              <span style={fontStyle}>{props.message}</span> 
          </Alert>;
}

export default LoadingMessage;